import { bigQuery, mixpanel } from '@fiverr-private/obs';

const getUserId = () =>
    window.dataLayer && window.dataLayer.length && window.dataLayer[0] && window.dataLayer[0].user_id;

const getReason = (tags = []) => {
    const REASON_KEYWORD = 'reason_';

    return tags
        .filter((item) => item.indexOf(REASON_KEYWORD) !== -1)
        .reduce((ac, item) => item.slice(REASON_KEYWORD.length), '');
};

const grizzliesBasicEvent = () => ({
    domain: {
        name: 'buyers',
    },
    publisher: {
        domain: 'buyers',
        sub_domain: 'grizzlies',
    },
});

const getBasicEvent = () => ({
    group: 'user_actions',
    platform: 'web',
    user: {
        id: getUserId(),
    },
    feature: {
        name: 'support_chat',
    },
    reason: 'support_chat_to_vibs',
    sub_group: 'website_actions',
    action: {
        type: 'click',
    },
});

export const chatTriggeredEvent = (tags) => {
    const event = {
        ...getBasicEvent(),
        ...grizzliesBasicEvent(),
        type: 'chat_triggered',
        reason: getReason(tags),
    };

    bigQuery.send(event);
};

export const forethoughtChatTriggeredEvent = ({ userId, uid }) => {
    const event = {
        ...getBasicEvent(),
        group: 'forethought_chatbot',
        type: 'chatbot_opened',
        user: { id: userId },
        uid,
        entity: 'business',
    };
    bigQuery.send(event);
    mixpanel.track('Viewed support chatbot', { source: window.location.pathname });
};
